import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { qualifications } from '@/mocks/evidence';

export default function Qualifications() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="公司资质"
            title="企业主体与官方身份"
            subtitle="华辉数智技术的企业资质、人工智能应用服务商申报方向与服务团联合单位身份。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {qualifications.map((q, i) => (
            <Reveal key={q.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${q.icon} text-primary-600 text-2xl`}></i>
                  </div>
                  {q.tag && (
                    <span className="px-2.5 py-1 text-[11px] rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
                      {q.tag}
                    </span>
                  )}
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{q.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{q.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}